var KR_I18n = KR_I18n || {};

KR_I18n["es-AR"] = {"amount":"Monto","qr_code_label":"Escaneá y pagá con [METHOD]"};

if ((typeof(module) !== "undefined") && (typeof(module.exports) !== "undefined")) module.exports = KR_I18n["es-AR"];

